import { connect } from "vuex-connect";
// import log from 'loglevel';
import { ComicSpine } from "../../../components";

export default connect({
  stateToProps: {
    isBusy: state => state.common.isBusy,
    defaultSpineImageUrl: state => state.uploadContents.defaultSpineImageUrl,
    initialSpineCoverType: state => state.uploadContents.spineCoverType,
    userSpineImageUrl: state => state.uploadContents.userSpineImageUrl,
    stepNumber: state => state.uploadContents.stepNumber,
    isUploadIceContents: state => state.uploadContents.isUploadIceContents
  },
  gettersToProps: {
    spineImageWidthRecommended: "uploadContents/spineImageWidthRecommended",
    spineImageHeightRecommended: "uploadContents/spineImageHeightRecommended",
    spineImageUrl: "uploadContents/spineImageUrl"
  },
  actionsToProps: {
    postUserSpineImage: (dispatch, value) =>
      dispatch("uploadContents/postUserSpineImage", value)
  },
  mutationsToProps: {
    setIsBusy: "common/setIsBusy",
    updateSpineCoverType: "uploadContents/updateSpineCoverType"
  }
})(ComicSpine.name, ComicSpine);
